import "./single.scss";

import UserChart from '../../components/chart/AreaChart/userOrdersArea'
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import UserTransactions from '../../components/table/singleUserTrans'
import { useState as uState, useEffect as uEffect} from "react";
import { useParams as uParams } from "react-router-dom";

import React from 'react'

export default function singleUser() {
    const { id } = uParams();


    const [user, setUser] = uState('');



    const fetchOneUser = () => {
        fetch("http://localhost:8000/users/oneUser", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ idToFound: id }),
        }).then(async (res) => {
            let response = await res.json()
            setUser(response)
        })
}   
    uEffect(() => {
fetchOneUser()
    }, [id])

  return (
      <>
      
      
          <div className="single">
              <Sidebar />
              <div className="singleContainer">
                  <Navbar />
                  <div className="top">
                      <div className="left">
                          <div className="editButton">Edit</div>
                          <h1 className="title">Information</h1>
                          <div className="item">
                              <img
                                  src={
                                      user.profileImg
                                          ?
                                      `http://localhost:8000/public/userImages/${user.profileImg}`                                  
                                          : "no image found from server"
                                    }
                                  alt=""
                                  className="itemImg"
                              />
                              <div className="details">
                                  <h1 className="itemTitle">{user.name}</h1>
                                  <div className="detailItem">
                                      <span className="itemKey">Email:</span>
                                      <span className="itemValue">{user.email}</span>
                                  </div>
                                  <div className="detailItem">
                                      <span className="itemKey">Phone:</span>
                                      <span className="itemValue">+91{user.mobile}</span>
                                  </div>
                                  <div className="detailItem">
                                      <span className="itemKey">Address:</span>
                                      <span className="itemValue">
                                          {user.address}
                                      </span>
                                  </div>
                                  <div className="detailItem">
                                      <span className="itemKey">Country:</span>
                                      <span className="itemValue">India</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="right">
                          <div className="chart">
                              <UserChart aspect={2/1} title={'User Spending'}/></div>

                      </div>
                  </div>
                  <div className="bottom">
                      <h1 className="title">Last Transactions</h1>
                      <UserTransactions/>
                  </div>
              </div>
          </div>
          
      </>
  )
}
